<template>
    <div class="khanesh-container">
        <!-- HEADER -->
        <div @click="open" class="sidenav-container">
            <img class="sidenav-btn" :src="GreenCircle" alt="GreenCircle">
            <img class="sidenav-btn burger" :src="Burger" alt="Burger">

            <span v-if="unread != 0" class="red-dot">.</span>
        </div>

        <div v-if="sidenavOpen" class="close" @click="close">

        </div>

        <div class="header">
            <div>
                <img class="header-logo" :src="Logo" alt="Logo">
                <img class="header-logo log-dot" :src="LogoDot" alt="LogoDot">

                <div class="header-desc">
                    <p v-if="haveAuth">{{ name }} عزیز،</p>
                    <h3>خوش آمدید...</h3>
                </div>

                <!-- 
                <div class="header-progress progress">
                    // 15 - 95
                    <div 
                        class="header-progress-bar progress-bar" 
                        role="progressbar" 
                        style="width: 75%"
                        aria-valuemin="0" 
                        aria-valuemax="100"
                    ></div>
                    <img class="header-progress-img" :src="NoBorderLogo" alt="NoBorderLogo">
                </div> 
                -->
            </div>

            <img class="header-img" :src="HoviatBasari" alt="HoviatBasari">
        </div>

        <!-- CONTENT -->
        <div class="content-container">
            <!-- SlideShow -->
            <SlideShow :imgList="favList"></SlideShow>

            <!-- Nav Menu -->
            <div class="menu-container row">
                <div class="menu-item" @click="() => menuItem = 'all'" :class="{ 'active': menuItem == 'all'}">
                    <small>همه</small>
                </div>
                <div class="menu-item" @click="() => menuItem = 'business'" :class="{ 'active': menuItem == 'business'}">
                    <img :src="KasboKar" alt="KasboKar">
                    <small>کسب و کار</small>
                </div>
                <div class="menu-item" @click="() => menuItem = 'crypto'" :class="{ 'active': menuItem == 'crypto'}">
                    <img :src="ArzeDigital" alt="ArzeDigital">
                    <small>ارز دیجیتال</small>
                </div>
                <div class="menu-item" @click="() => menuItem = 'financial'" :class="{ 'active': menuItem == 'financial'}">
                    <img :src="Tax" alt="Tax">
                    <small>مالی و مالیاتی</small>
                </div>
            </div>

            <!-- Posts -->
            <KhebregiResults :resultList="resultList"></KhebregiResults>
        </div>
    </div>
</template>

<script>
import Logo from '@/assets/images/khanesh/logo.png';
import LogoDot from '@/assets/images/khanesh/logo_dot.png';
import NoBorderLogo from '@/assets/images/khanesh/noborder_logo.png';
import Burger from '@/assets/images/khanesh/burger.png';
import GreenCircle from '@/assets/images/khanesh/green_circle.png';
import HoviatBasari from '@/assets/images/khanesh/hoviat_basari.png';

import ArzeDigital from '@/assets/images/result-types/arze_digital.png';
import KasboKar from '@/assets/images/result-types/kasbo_kar.png';
import Tax from '@/assets/images/result-types/tax.png';

// import ManTest from '@/assets/images/man_test.jpg';

import SlideShow from '@/components/SlideShow';
import KhebregiResults from '@/components/KhebregiResults';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'Khanesh',
    data() {
        return {
            Logo: Logo,
            LogoDot: LogoDot,
            NoBorderLogo: NoBorderLogo,

            Burger: Burger,
            GreenCircle: GreenCircle,

            HoviatBasari: HoviatBasari,

            ArzeDigital: ArzeDigital,
            KasboKar: KasboKar,
            Tax: Tax,

            favList: [],
            resultList: [],

            unread: 0,

            menuItem: 'all',
            URL: APP_API_URL(),
            name: undefined,
            haveAuth: false,
            sidenavOpen: false,
        }
    },
    components: {
        SlideShow,
        KhebregiResults
    },
    mounted() {
        // this.getFavs();
        this.GetUser();
        this.getSlides();
        this.GetNotif();
    },
    watch: {
        menuItem: {
            handler: 'getPosts',
            immediate: true
        },
        '$route'() {
            this.GetNotif();
        }
    },
    methods: {
        GetNotif() {
            getRequest('/notifications/find-all')
                .then(rsp => {
                    // response
                    this.unread = 0;

                    (rsp.data).forEach(msg => {
                        if((msg.CleanUsers || []).indexOf(this.userId) == -1) {
                            this.unread += 1;
                        }
                    });
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            // Cookies.remove('access_cookie');
                            // this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        getSlides() {
            getRequest('/slides/find-all')
                .then((rsp) => {
                    rsp['data'].forEach(fav => {
                        if(fav.Cover) {
                            this.favList.push({
                                Cover: this.URL + '/' + fav.Cover,
                                Link: fav.Link
                            })
                        }
                    });
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            // Cookies.remove('access_cookie');
                            // this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        GetUser() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    let data = rsp['data'];
                    this.name = data.FirstName;

                    this.haveAuth = true;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            // Cookies.remove('access_cookie');
                            // this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        getPosts() {
            let query = {}
            if(this.menuItem != 'all') query['type'] = this.menuItem;

            getRequest('/posts/find-latest', query)
                .then((rsp) => {
                    // response
                    this.resultList = rsp['data']
                })
                .catch(() => {
                    // error
                });
        },
        // getFavs() {
        //     getRequest('/posts/find-favorites')
        //         .then((rsp) => {
        //             // response
        //             rsp['data'].forEach(fav => {
        //                 if(fav.Cover) {
        //                     this.favList.push({
        //                         Cover: this.URL + '/' + fav.Cover,
        //                         Id: fav._id
        //                     })
        //                 }
        //             });
        //         })
        //         .catch(() => {
        //             // error
        //         });
        // },
        logout() {
            if (Cookies.get('access_cookie')) {
                postRequest('/users/logout')
                    .then(() => {
                        // response
                        Cookies.remove('access_cookie')
                        this.$router.push({ name: 'Login' })

                        location.reload();
                    })
                    .catch(() => {
                        // error
                    });
            }
        },
        close() {
            let w = this.$root.$refs.mySidenav.style.width;
            if (w == '180pt') {
                this.sidenavOpen = false;
                this.$root.$refs.mySidenav.style.width = '0pt';
                document.getElementById('public-container').style.overflow = 'scroll';
            }
        },
        open() {
            let w = this.$root.$refs.mySidenav.style.width;

            if (w == '180pt') {
                this.sidenavOpen = false;
                this.$root.$refs.mySidenav.style.width = '0pt';
                document.getElementById('khanesh-container').style.overflow = 'scroll';
            }
            else {
                this.sidenavOpen = true;
                this.$root.$refs.mySidenav.style.width = '180pt';
                document.getElementById('public-container').style.overflow = 'hidden';
            }
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.khanesh-container {
    overflow: scroll;
    height: 100vh;
}
.khanesh-container .red-dot {
    color: red; 
    font-size: 5rem; 
    line-height: 1rem;
    text-align: center; 
    
    width: 50pt; 
    position: absolute; 
    top: -2px; 
    right: calc(7.4vh - 22pt);
}
.khanesh-container .header {
    height: 45vh;
    width: 100vw;

    position: relative;
    overflow: hidden;

    background-color: #ffce02;
    background-image: linear-gradient(135deg, #f9e592, transparent);
}
.khanesh-container .sidenav-container {
    position: fixed;
    z-index: 10;
}
.khanesh-container .close {
    height: 100vh;
    width: 100%;

    background-color: #ddd;

    position: absolute;
    top: 0;
    left: 0;

    z-index: 1032;
}
.khanesh-container .sidenav-container .sidenav-btn {
    height: 50pt;
    width: 50pt;

    right: calc(7.4vh - 22pt);
    top: 10pt;

    position: absolute;
    cursor: pointer;
}
.khanesh-container .sidenav-container .burger {
    height: 10pt;
    width: 31pt;

    right: calc(7.4vh - 12.5pt);
    top: 30pt;
}
.khanesh-container .header .header-logo {
    height: 65pt;

    left: 35pt;
    top: 40pt;

    position: absolute;
}
.khanesh-container .header .log-dot {
    height: 15.5pt;
    width: 15.5pt;

    left: 95pt;
    top: 80pt;
}
.khanesh-container .header .header-img {
    height: 42.5vh;

    right: -12.5vh;
    bottom: -15vh;

    position: absolute;
}
.khanesh-container .header .header-desc {
    height: 40pt;
    width: 165pt;

    display: flex;
    flex-direction: column;

    position: absolute;
    text-align: center;
    
    left: 20pt;
    top: 105pt;
}
.khanesh-container .header .header-desc p {
    margin-bottom: .25rem;
}
.khanesh-container .header .header-progress {
    height: 20pt;
    width: 91.875pt;
    border-radius: 10pt;

    background-color: rgba(239, 195, 9, 0.8);
    background-image: linear-gradient(180deg, #bb9700, transparent);

    position: absolute;
    direction: ltr;
    
    left: 20pt;
    top: 110pt;
}
.khanesh-container .header .header-progress-bar {
    height: 14pt;
    
    margin-top: 3pt;
    margin-left: 2.5pt;
    
    border-radius: 8pt;
    background-color: #ffff00;
}
.khanesh-container .header .header-progress-img {
    height: 26pt;
    width: 19pt;
    margin-left: -16pt;
}

/* ---------------------------------------- */
/* ---------------- CONTENT --------------- */
/* ---------------------------------------- */
.khanesh-container .content-container {
    width: 100%;

    margin-top: -9vh;;
    padding-top: 13pt;
    position: relative;

    border-radius: 9vh;

    background-color: #ebecf1;
}
/* nav manu */
.khanesh-container .content-container .menu-container {
    margin: 10pt;
}
.khanesh-container .content-container .menu-item {
    height: 40pt;
    width: calc(25% - 4pt);

    display: flex;
    flex-direction: column;
    cursor: pointer;

    margin: 0 2pt;
    
    border: 3px solid rgba(255, 255, 255, .5);
    border-radius: 10pt;
    background-color: #ebecf1;
    box-shadow: 5px 5px 5px #ddd;

    text-align: center;
}
.khanesh-container .content-container .active {
    border: none;
    padding: 3px;
    box-shadow: inset 0 0 5px 2px #ddd;
}
.khanesh-container .content-container .menu-item img {
    height: 10pt;

    margin: auto;
    margin-top: 5pt;
    display: inline-block;

}
.khanesh-container .content-container .menu-item small {
    display: inline-block;
    margin: auto;

    font-weight: bold;
}
@media (max-width: 400px) {
    .khanesh-container .content-container .menu-item small {
        font-size: 60%;
    }
}
</style>
